import { AppForm } from '../../common/forms/app.form';
import { Injectable } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { UserBaseAllBaseWriteUserAllUserWrite } from '../../openapi';
import { UserDetails } from '../../store/reducers/user-details.reducer';

export interface UserDetailsFormValue {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  street: string;
  houseNumber: string;
  apartmentNumber: string;
  city: string;
  postalCode: string;
  postOffice: string;
  notificationsConsent: boolean;
  termsConsent: boolean;
  gdprConsent: boolean;
}

@Injectable()
export class UserDetailsForm extends AppForm {
  constructor() {
    super({
      firstName: new FormControl('', { validators: [], nonNullable: true }),
      lastName: new FormControl('', { validators: [], nonNullable: true }),
      email: new FormControl('', { validators: [Validators.required, Validators.email], nonNullable: true }),
      phoneNumber: new FormControl('', { validators: [], nonNullable: true }),
      street: new FormControl('', { validators: [], nonNullable: true }),
      houseNumber: new FormControl('', { validators: [], nonNullable: true }),
      apartmentNumber: new FormControl('', { validators: [], nonNullable: true }),
      city: new FormControl('', { validators: [], nonNullable: true }),
      postalCode: new FormControl('', { validators: [], nonNullable: true }),
      postOffice: new FormControl('', { validators: [], nonNullable: true }),
      notificationsConsent: new FormControl(false, { validators: [], nonNullable: false }),
      termsConsent: new FormControl(false, { validators: [Validators.requiredTrue], nonNullable: false }),
      gdprConsent: new FormControl(false, { validators: [Validators.requiredTrue], nonNullable: false })
    });
  }

  public override patchFormValues(value?: UserDetails | null): void {
    if (value) {
      this.patchValue(value);
    }
  }

  public toWriteValue(): UserBaseAllBaseWriteUserAllUserWrite {
    const v: UserDetailsFormValue = this.value;
    return {
      city: v.city,
      email: v.email,
      houseNumber: v.houseNumber,
      apartmentNumber: v.apartmentNumber,
      firstName: v.firstName,
      lastName: v.lastName,
      phoneNumber: v.phoneNumber,
      postalCode: v.postalCode,
      postOffice: v.postOffice,
      street: v.street,
      gdprConsent: v.gdprConsent,
      notificationsConsent: v.notificationsConsent,
      termsConsent: v.termsConsent
    };
  }
}
